export default __webpack_public_path__ + "static/media/tete88.d6c52dd7.png";